import EventEmitter from 'eventemitter3';
import { Timer } from 'tccc-utils';
import { RtcSocket } from './socket/socket';
import i18next from './i18n/i18next.config';
import { Call } from './tccc/Call';
import { Chat } from './tccc/Chat';
import { Video } from './tccc/Video';
import { Devices } from './tccc/Devices';
import { Agent } from './tccc/Agent';
import { Proxy } from './tccc/Proxy';
import { TcccEvents } from './tccc/events';
import { setUrlConfig } from './config';
import { store } from './store';
import { getSessionList } from './store/sessions/sessions.thunk';
import { TIM } from './tim/tim';
import { ASR } from './tccc/ASR';
import { WatchMicrophonesPermissionChange } from './trtc/Permission';
import { Request } from './http';
export { default as TIMSDK } from 'tim-js-sdk';
export type {
  Message,
  TextMessage,
  FileMessage,
  FaceMessage,
  ImageMessage,
  LocationMessage,
  VideoMessage,
  CustomMessage,
  CreateMessageParams,
  CreateAudioMessageParams,
  CreateLocationMessageParams,
  CreateFaceMessageParams,
  CreateCustomMessageParams,
  CreateVideoMessageParams,
  CreateFileMessageParams,
  CreateTextMessageParams,
  CreateImageMessageParams,
} from './tim/tim';
export type TcccEventEmitter = EventEmitter<TcccEvents>;
export * from './tccc/events';

const instance: Record<string, TcccSdk> = {};
export class TcccSdk extends EventEmitter<TcccEvents> {
  static #instance: Record<string, TcccSdk>;
  static createAgent = async ({
    sdkAppId,
    userId,
    token,
    origin,
  }: {
    sdkAppId: string;
    userId: string;
    token?: string;
    origin?: string;
  }) => {
    if (sdkAppId && userId && instance[sdkAppId + userId]) return instance[sdkAppId + userId];
    const agent = new TcccSdk();
    Object.assign(instance, {
      [sdkAppId + userId]: agent,
    });
    await agent.Agent.createAgent({ sdkAppId, userId, token, origin });
    return agent;
  };

  socket: RtcSocket | null;
  tim: TIM | null;
  readonly timer: Timer;
  readonly http: Request;
  public Agent = new Agent(this);
  public Call = new Call(this);
  public Chat = new Chat(this);
  public Video = new Video(this);
  public Asr = new ASR(this);
  public Devices = new Devices(this);
  public Proxy = new Proxy(this);

  constructor() {
    super();
    this.socket = null;
    this.tim = null;
    this.timer = new Timer();
    this.http = new Request(this);

    WatchMicrophonesPermissionChange();
  }
  public getConversationList() {
    return store.dispatch(getSessionList({ tccc: this })).unwrap();
  }

  setProxy(params: Parameters<typeof setUrlConfig>[0]) {
    setUrlConfig(params);
  }

  changeLanguage(lang?: string) {
    return i18next.changeLanguage(lang);
  }
}
